<script>
  import { ignore } from "../../Common/tools";
  import QuizFormHeadingStyling from "./QuizFormHeadingStyling.svelte";
  import {External, M} from "../../external";
  export let widget, step,
    onChange = ignore;

  let changeHeadingStyles = () => {
    External.Tools.showWindow({
      isModal: false,
      title: M.HEADING_DESCRIPTION_STYLING,
      icon: External.Popup.ICON_ADD,
      width: 400,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new QuizFormHeadingStyling({
              target: popup.getContentArea(),
              props: {
                widget: widget,
                onChange: onChange
              }
            })
          );
        }
      }
    });
  };
</script>

<div class="popup-widget-wrapper">
  <div class="popup-input-wrapper f-left mt-35">
    <div class="col20 info">
      <h5>{M.STEP_HEADING}</h5>
      <span>{M.STEP_HEADING_DESC}</span>
    </div>
    <input type="text" class="transition-background" bind:value={step.heading} on:blur={onChange} />

    <div class="col20 info mt-15">
      <h5>{M.STEP_DESCRIPTION}</h5>
      <span>{M.STEB_SUBHEADING_DESC}</span>
    </div>
    <input type="text" class="transition-background" bind:value={step.subHeading} on:blur={onChange} />
  </div>
  <div class="col20 mt-15 mb-5 f-left gray-section product-select-wrapper">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">{M.HEADING_DESCRIPTION_STYLING}</h4>
      <a class="text-link blue-text" on:click={changeHeadingStyles}>{M.STYLE}</a>
    </div>
  </div>
</div>
